import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { assignmentProgressWithTagPairs } from 'legacy-src/queries';
import RouteWrapper from 'legacy-src/components/assessment/Results/RouteWrapper';
import { isPriorStudentsPage } from 'legacy-src/utility/utils';
import { getEducationPeriodForSubject } from 'legacy-src/components/auth/utils';

const { bool, string, shape } = PropTypes;

/**
 * Wraps the results deciding where to go
 * */
const ResultsWrapper = (props) => {
  const { children, ...otherProps } = props;

  const { tagPairsData } = otherProps;
  const { loading } = tagPairsData || {};

  if (loading) {
    return <LoadingSpinner />;
  }

  return React.Children.toArray(children).map((child) =>
    React.cloneElement(child, otherProps),
  );
};

ResultsWrapper.propTypes = {
  /**
   * Student context
   * */
  studentContext: shape({
    hasContext: bool,
    studentId: string,
    resultsPath: string,
    progressPath: string,
    questionsPath: string,
  }),
};

ResultsWrapper.defaultProps = {
  studentContext: {
    hasContext: false,
    studentId: null,
    resultsPath: '',
    progressPath: '',
    questionsPath: '',
  },
};

const withTagPairs = graphql(assignmentProgressWithTagPairs, {
  name: 'tagPairsData',
  options: (props) => {
    const {
      isPPC,
      studentContext: { studentId },
      assignment: { id },
      courseOutlineConfig: {
        data: { ppcTagPair },
      },
      routes,
      params,
      userData,
    } = props;
    const includePriorStudents = isPriorStudentsPage(routes);
    return {
      fetchPolicy: 'network-only',
      skip: !isPPC,
      variables: {
        tags: ppcTagPair,
        assignmentId: id,
        studentId: studentId || null,
        includePriorStudents: includePriorStudents ? 'include' : null,
        educationPeriod: getEducationPeriodForSubject({
          subjectId: params.subject.toString(),
          userData,
        }),
      },
    };
  },
});

export default compose(RouteWrapper, withTagPairs)(ResultsWrapper);
